import React, { Component } from "react"
import ReactPixel from "react-facebook-pixel"
import ReactGA from "react-ga"

import Hero from "../components/ladakh/hero/hero"
import SEO from "../components/seo"
import Adventures from "../components/ladakh/norway/norway"
import Footer from "../components/ladakh/footer/footer"
import "../style/ladakh.css"
import CustomQueryStringComponent from "../components/customQueryStringComponent"

class SecondPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      FilterList: [],
    }
  }
  test = (value, season) => {
    let filters = value.norwayItems.filter(
      person => person.item.status.season === season
    )
    console.log("filtes", filters)
    this.setState({
      FilterList: filters,
    })
  }
  render() {
    const trackingId = "UA-24117780-3" // Replace with your Google Analytics tracking ID
    ReactGA.initialize(trackingId)

    if (typeof window !== `undefined`) {
      const advancedMatching = { em: "some@email.com" }
      const options = {
        autoConfig: true, // set pixel's autoConfig
        debug: false, // enable logs
      }
      ReactPixel.init("2151876878446248", advancedMatching, options)
      ReactPixel.pageView() // For tracking page view
    }
    return (
      <div>
        <SEO
          title="Norway"
          description="Norway's finest tours hand selected by Great Guides"
        />
        <Hero
          // title="Great Norway Tours"
          title=<CustomQueryStringComponent />
          special="Find the best deals for Norway with Great Guides"
          description=""
          bgImage="https://greatguides-prod-media.s3.amazonaws.com/Trips/Norway/North+Cape+Lapland+Aurora+Borealis/north-cape-norway.jpg"
          // description="Our great guides Eirik Iversen, Hanne Hollas amd Elise Koren are true norwegian explorers. They wanted to continue their passion and love for the outdoors. They lead our unique trips in the Fjords and Arctic region of Norway."
        />

        <Adventures test={this.test} filterList={this.state.FilterList} />
        <Footer />
      </div>
    )
  }
}

export default SecondPage
